/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { getAllModuleAction, setAvailableModulesList } from './moduleActionCreator';
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../shared/constants';
import { setSnackBarDisplay } from '../snackBar/snackBarActionCreator';
import { showErrorAction, clearErrorAction } from "../error/errorActionCreator";
import { hideLoaderAction, showLoaderAction } from "../loader/loaderActionCreator";
import { createNewModule, deleteModule, getModulesForAnApplication, updateModule } from '../../services/modules';
import {
  getModulePayload,
  IDeleteModuleRequest,
  IModuleCreate,
  IModuleEdit,
} from '../../models/modules/module';
import { getValidationErrorMessages } from '../../utility/commonUtility';

export const getModules = async (dispatch: Function, modulePayload: getModulePayload) => {
  let modules: any = [];
  let pagination: any = {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  };
  let selectedModule: any = {};
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const moduleResponse = await getModulesForAnApplication(modulePayload);
    if (moduleResponse.data.length) {
      modules = moduleResponse.data;
      pagination = moduleResponse.metadata;
      selectedModule = modules[0];
      dispatch(getAllModuleAction(modules, selectedModule, pagination, modules.length > 0 ? false : true));
      dispatch(setAvailableModulesList(modules))
    } else {
      dispatch(getAllModuleAction([], {}, pagination, true));
    }
    dispatch(hideLoaderAction());
    return modules;
  } catch (error) {
    const errorMessage = {
      message: 'Error in fetching Modules: ' + error
    };
    modules = [];
    selectedModule = {};
    dispatch(getAllModuleAction(modules, selectedModule, pagination, false));
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in fetching Modules: ' + error,
        severity: 'error',
      })
    );
    return false;
  }
};

export const createModule = async (dispatch: Function, modulePayload: IModuleCreate) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const createModuleResponse = await createNewModule(modulePayload);
    if (createModuleResponse.id) {
      getModules(dispatch, { organizationId: modulePayload.organizationId, applicationId: modulePayload.applicationId });
    }
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Module created successfully',
        severity: 'success',
      })
    );
    return true;
  } catch (error: any) {
    let errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in creating Module: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in creating Module: ' + errorMessageDetail,
        severity: 'error',
      })
    );
    return false;
  }
};

export const editModule = async (dispatch: Function, editModulePayload: IModuleEdit) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    await updateModule(editModulePayload);
    getModules(dispatch, { organizationId: editModulePayload.organizationId, applicationId: editModulePayload.applicationId });
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        severity: 'success',
        message: 'Module updated successfully',
      })
    );
    return true;
  } catch (error: any) {
    let errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in Edit Module: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        severity: 'error',
        message: 'Error in Edit Module: ' + errorMessageDetail,
      })
    );
    return false;
  }
};

export const removeModule = async (dispatch: Function, deleteModulePayload: IDeleteModuleRequest) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    await deleteModule(deleteModulePayload);
    getModules(dispatch, { organizationId: deleteModulePayload.organizationId, applicationId: deleteModulePayload.applicationId });
    dispatch(hideLoaderAction());
    return true;
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in delete Module: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in delete module: ' + errorMessageDetail,
        severity: 'error',
      })
    );
  }
};
